import React from 'react';
import { Box, Divider } from '@mui/material';
import { bool, number, shape, string } from 'prop-types';
import { AUTHORIZATION_TYPE } from 'feature/loading-management/utils/const';

// utils
import { useUserRolePermissions } from 'hooks';

// components
import SupplierAuthLimit from './SupplierAuthLimit';
import SupplierAuthLimitLabel from './SupplierAuthLimitLabel';
// TODO: temporarily commenting out the last used Date(CTDP-125)
// import SupplierAuthLastUsed from './SupplierAuthLastUsed';
import SupplierAuthEndDate from './SupplierAuthEndDate';
import TwoPartyExchange from './TwoPartyExchange.connector';
import TwoPartyExchangeLabel from './TwoPartyExchangeLabel';
import SupplierAuthLimitRemainingVolume from './SupplierAuthLimitRemainingVolume';

const SupplierAuthCardBody = ({
  cardBodyData,
  locationName,
  productAuthorizationId,
  productName,
  supplierName,
}) => {
  const {
    active,
    endDate,
    exchange,
    // TODO: temporarily commenting out the last used Date(CTDP-125)
    // lastUsed,
    limitMet,
    limitType,
    limitVolume,
    loadableVolume,
    loadableVolumeUnitOfMeasure,
    remainingVolume,
    unlimited,
  } = cardBodyData;
  const selfType = limitType === AUTHORIZATION_TYPE.SELF;
  const { isProductLoadingManage } = useUserRolePermissions();

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between" mb={1}>
        {/* TODO: temporarily commenting out the last used Date(CTDP-125); need to import Divder when uncommenting the code.
        <Divider width="47%" />
        <Divider width="47%" /> */}
        <Divider width="100%" />
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mb={2}>
        {/* 
          TODO: A backend bug is sending the wrong no-end-date (
            9999-12-31T23:59:59 instead of
            2999-12-31T23:59:59
          ) so we need this patch until that's fixed
        */}
        <SupplierAuthEndDate
          endDate={limitType === AUTHORIZATION_TYPE.SELF ? '2999-12-31T23:59:59' : endDate}
        />
        {/* TODO: temporarily commenting out the last used Date(CTDP-125)
        <SupplierAuthLastUsed lastUsed={lastUsed} /> */}
      </Box>
      {isProductLoadingManage ? (
        <>
          <SupplierAuthLimit
            active={active}
            limitData={{
              limitMet,
              limitType,
              limitVolume,
              loadableVolume,
              loadableVolumeUnitOfMeasure,
            }}
            unlimited={unlimited}
          />
          <SupplierAuthLimitRemainingVolume
            active={active}
            remainingVolumeData={{
              remainingVolume,
            }}
          />
          {selfType ? (
            <TwoPartyExchangeLabel exchange={exchange} m={0} selfType={selfType} />
          ) : (
            <TwoPartyExchange
              active={active}
              exchange={exchange}
              locationName={locationName}
              productAuthorizationId={productAuthorizationId}
              productName={productName}
              supplierName={supplierName}
            />
          )}
        </>
      ) : (
        <>
          <SupplierAuthLimitLabel active={active} />
          <SupplierAuthLimitRemainingVolume
            active={active}
            remainingVolumeData={{
              remainingVolume,
            }}
          />
          <TwoPartyExchangeLabel exchange={exchange} selfType={selfType} />
        </>
      )}
    </Box>
  );
};

export default SupplierAuthCardBody;

SupplierAuthCardBody.propTypes = {
  cardBodyData: shape({
    active: bool.isRequired,
    endDate: string,
    exchange: shape({}),
    lastUsed: string,
    limitMet: bool,
    limitType: string,
    limitVolume: number,
    loadableVolume: number,
    unlimited: bool.isRequired,
  }).isRequired,
  locationName: string.isRequired,
  productAuthorizationId: number.isRequired,
  productName: string,
  supplierName: string.isRequired,
};

SupplierAuthCardBody.defaultProps = {
  productName: '',
};
